export type MonerisTokenizationResponse = {
    responseCode: string[];
    errorMessage?: string;
    dataKey?: string;
};

export function getMonerisTokenizationResponse(data: any): MonerisTokenizationResponse | null {
    if (!data || typeof data !== "string") {
        return null;
    }

    let parsedData: MonerisTokenizationResponse;
    try {
        parsedData = JSON.parse(data) as MonerisTokenizationResponse;
    }
    catch(error) {
        return null;
    }

    if (parsedData.responseCode !== undefined) {
        return parsedData;
    }

    return null;
}
